import momentGenerateConfig from "rc-picker/lib/generate/moment";
var generateConfig = momentGenerateConfig;
if (!generateConfig.getMillisecond) {
  generateConfig.getMillisecond = function (date) {
    return date.millisecond();
  };
  generateConfig.setMillisecond = function (date, millisecond) {
    var clone = date.clone();
    return clone.millisecond(millisecond);
  };
}
export default generateConfig;